import { Badge } from '../../Utility/Badge';
import React from 'react';
import LoadingSpinner from '../../Utility/LoadingSpinner';
import { InfoBoxProps } from '../../../Types';

const InfoBox = React.memo(
    ({
        title,
        smallTitle = false,
        loading = false,
        value,
        badgeText,
        badgeVariant,
        previousValue,
        previousLabel,
        children,
    }: InfoBoxProps) => (
        <div className={`h-full box max-w-[unset]`}>
            {smallTitle ? <p className="text-gray-500">{title}</p> : <h4 className="mt-0 mb-3">{title}</h4>}
            {loading ? (
                <LoadingSpinner />
            ) : (
                <>
                    {value && <h2>{value}</h2>}
                    {badgeText && <Badge variant={badgeVariant} className={previousValue ? "mr-1" : ""}>{badgeText}</Badge>}
                    {previousValue && (
                        <Badge variant="success">
                            {previousLabel}: {previousValue}
                        </Badge>
                    )}
                    {children}
                </>
            )}
        </div>
    ),
);

export default InfoBox;
